import { axios } from '../libraries'

const api = axios.create({
  baseURL: 'http://iskindo.or.id/jANqMHa/Sr7YrHa/api/'
})

export default api
